import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordRulesValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    const minLength = value.length >= 8;
    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasNumber = /[0-9]/.test(value);
    const hasSpecialChar = /[!@#$%&*]/.test(value);

    const isValid = minLength && hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar;

    if (isValid) {
      return null;
    }

    return {
      passwordRules: {
        minLength: !minLength,
        upperCase: !hasUpperCase,
        lowerCase: !hasLowerCase,
        number: !hasNumber,
        specialChar: !hasSpecialChar
      }
    };
  };
}
